module.exports = __webpack_public_path__ + "img/sprinkle-2.1004b67d.jpg";